import { auth } from "../firebase";
import { resolveApiBaseUrl } from "./apiBase";

async function buildAuthHeaders() {
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const token = await auth.currentUser?.getIdToken?.();
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    // Best effort header enrichment.
  }

  return headers;
}

export async function uploadVideoToFacebookPage({ certId, downloadUrl, title, description }) {
  const baseUrl = resolveApiBaseUrl();
  // Certify-first: the backend resolves the video URL from videos/{certId}, so
  // downloadUrl is optional and only included when a caller explicitly passes one.
  const body = { certId, title, description };
  if (downloadUrl) body.downloadUrl = downloadUrl;
  const response = await fetch(`${baseUrl}/v1/facebook/page-video-upload`, {
    method: "POST",
    headers: await buildAuthHeaders(),
    body: JSON.stringify(body),
  });

  const text = await response.text();
  let payload = {};
  try {
    payload = text ? JSON.parse(text) : {};
  } catch {
    payload = { raw: text };
  }

  if (!response.ok) {
    const message = payload?.error?.message || payload?.message || `Facebook upload failed (${response.status})`;
    throw new Error(message);
  }

  return payload;
}
